module.exports = __webpack_public_path__ + "img/incorrect_icon.626f3ede.svg";